// A PO's type and name, as the PO list, the PO's header and the side pane's title show them (Mitch, 2026-11-04: "MAKE -
// PO-1023 - Elecrow", and the type on the POs screen "so we can clearly separate types of purchase orders").
import type { Po, Vendor } from "../../../../shared/db.gen.ts";
import { PO_KIND_LABELS } from "../../../../shared/po.ts";
import { cx } from "../../ui/controls.tsx";
import { vendorLabel } from "./lib.ts";

/** A PO as one line: its type, its number and its vendor ("MAKE · PO-1023 · Elecrow"), as the pane's title and its header. */
export function PoName({ po, vendor }: { po: Po; vendor: Vendor | undefined }) {
  return (
    <span className="inline-flex min-w-0 items-baseline gap-1.5">
      <PoType kind={po.kind} />
      <span className="font-mono font-semibold">{po.number}</span>
      <span className="text-faint">·</span>
      <span className="truncate">{vendorLabel(vendor)}</span>
    </span>
  );
}

/** A PO's type in a word, its own colour each, so the kinds of PO stand apart (the PO list's Type column too). */
export function PoType({ kind }: { kind: Po["kind"] }) {
  return (
    <span
      className={cx(
        "shrink-0 rounded px-1.5 py-px text-[10px] font-semibold tracking-wide uppercase",
        kind === "make" ? "bg-accent-soft text-accent-text" : kind === "service" ? "bg-warn-soft text-warn" : "bg-surface-2 text-muted",
      )}
    >
      {PO_KIND_LABELS[kind]}
    </span>
  );
}
